const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i
const HEX_LONG = /^[0-9a-f]{8,}$/i
const DIGITS = /^\d+$/

/** Сегмент после него — идентификатор источника: он бывает и словом (`source-a`), поэтому по виду не узнаётся. */
const COLLECTION_BEFORE_ID = 'resources'

/** Длиннее — это ключ или токен, а не слово маршрута. */
const LONGEST_WORD = 32

function isIdentifier(segment: string): boolean {
  if (segment === '') return false
  if (segment.includes('%')) return true
  if (UUID.test(segment) || DIGITS.test(segment) || HEX_LONG.test(segment)) return true
  if (segment.length > LONGEST_WORD) return true
  // Смесь букв и цифр заметной длины (`op_1234abcd`) — идентификатор; короткое `v1`, `v4` — слово маршрута.
  return segment.length >= 8 && /\d/.test(segment) && /[a-z]/i.test(segment)
}

/**
 * Шаблон маршрута для трассировки: путь запроса без параметров, фрагмента и идентификаторов — они заменяются на `{id}`.
 * `/api/aqsi/v1/resources/8f…/pos/registers/7/shift?x=1` → `/api/aqsi/v1/resources/{id}/pos/registers/{id}/shift`.
 * Параметры запроса отбрасываются целиком: в них бывает поисковая строка и другие данные человека. Единственная функция
 * нормализации — подробная трассировка не пишет в журнал ничего, кроме её результата.
 */
export function routeTemplateOf(url: string): string {
  const end = url.search(/[?#]/)
  const path = end < 0 ? url : url.slice(0, end)
  const segments = path.split('/').filter((segment, index) => segment !== '' || index === 0)
  const result = segments.map((segment, index) => {
    const previous = segments[index - 1]
    return previous === COLLECTION_BEFORE_ID || isIdentifier(segment) ? '{id}' : segment
  })
  const joined = result.join('/')
  return joined === '' ? '/' : joined
}

/** Служебные маршруты самой трассировки: сами себя в подробном режиме не пишут (иначе отправка порождала бы события). */
export function isTraceRoute(route: string): boolean {
  return route.includes('/trace/')
}
